<script>

export default {
    name: "screenshot-carousel",
    props: {
        screenshots: Array,
        index: Number
    },
    computed: {
        translations() {
            return {
                screenshotTaken: Lang.langGet("Screenshot taken"),
                noScreenshot: Lang.langGet("No Screenshot")
            }
        },
        selectedScreenshot() {
            if (!this.screenshots.length) return null;

            return this.screenshots[this.index];
        }
    }
}
</script>

<template>
    <div class="d-flex align-center justify-center flex-column">
        <div v-if="selectedScreenshot" class="d-flex align-center justify-center ma-2">
            <v-icon class="ma-12" :disabled="index === 0" @click="$emit('backward', 1)">fa-regular fa-caret-left</v-icon>
            <div class="d-flex align-center justify-center flex-column" style="user-select: none">
                <img class="rounded screenshot-img" alt="picBig" :src="selectedScreenshot.data"/>
                <div class="text-h5 mt-1">{{ translations.screenshotTaken + ': ' + selectedScreenshot.date_local }}</div>
            </div>
            <v-icon class="ma-12" :disabled="index === screenshots.length - 1" @click="$emit('forward', 1)">fa-regular fa-caret-right</v-icon>
        </div>
        <div v-else class="d-flex align-center justify-center text-h4">
            {{translations.noScreenshot}}
        </div>
        <div class="screenshot-carousel-preview d-flex flex-row align-center justify-center ma-2 pa-2">
            <v-icon size="large" v-show="index > 2" @click="$emit('backward', 3)">fa-regular fa-circle-ellipsis</v-icon>
            <div v-if="screenshots[index - 3]" class="cursor-pointer ma-1" @click="$emit('backward', 3)">
                <img class="rounded screenshot-carousel-preview-img mx-2" alt="previousPicture" :src="screenshots[index - 3]?.data"/>
                <div class="text-center screenshot-carousel-preview-sub">{{ screenshots[index - 3]?.date_local }}</div>
            </div>
            <div v-else style="width: 100px; display: inline-block" />
            <div v-if="screenshots[index - 2]" class="cursor-pointer ma-1" @click="$emit('backward', 2)">
                <img class="rounded screenshot-carousel-preview-img mx-2" alt="previousPicture" :src="screenshots[index - 2]?.data"/>
                <div class="text-center screenshot-carousel-preview-sub">{{ screenshots[index - 2]?.date_local }}</div>
            </div>
            <div v-else style="width: 100px; display: inline-block" />
            <div v-if="screenshots[index - 1]"  class="cursor-pointer ma-1" @click="$emit('backward', 1)">
                <img class="rounded screenshot-carousel-preview-img mx-2" alt="previousPicture" :src="screenshots[index - 1]?.data"/>
                <div class="text-center screenshot-carousel-preview-sub">{{ screenshots[index - 1]?.date_local }}</div>
            </div>
            <div v-else style="width: 100px; display: inline-block" />
            <div v-if="selectedScreenshot" class="ma-2" @click="$emit('forward', 0)">
                <img class="rounded screenshot-carousel-preview-img screenshot-carousel-preview-selected mx-2" alt="currentPicture" :src="screenshots[index]?.data"/>
                <div class="text-center screenshot-carousel-preview-sub">{{ screenshots[index]?.date_local }}</div>
            </div>
            <div v-if="screenshots[index + 1]" class="cursor-pointer ma-1" @click="$emit('forward', 1)">
                <img class="rounded screenshot-carousel-preview-img mx-2" alt="nextPicture" :src="screenshots[index + 1]?.data"/>
                <div class="text-center screenshot-carousel-preview-sub">{{ screenshots[index + 1]?.date_local }}</div>
            </div>
            <div v-else style="width: 100px; display: inline-block" />
            <div v-if="screenshots[index + 2]" class="cursor-pointer ma-1" @click="$emit('forward', 2)">
                <img class="rounded screenshot-carousel-preview-img mx-2" alt="nextPicture" :src="screenshots[index + 2]?.data"/>
                <div class="text-center screenshot-carousel-preview-sub" >{{ screenshots[index + 2]?.date_local }}</div>
            </div>
            <div v-else style="width: 100px; display: inline-block" />
            <div v-if="screenshots[index + 3]" class="cursor-pointer ma-1" @click="$emit('forward', 3)">
                <img class="rounded screenshot-carousel-preview-img mx-2" alt="nextPicture" :src="screenshots[index + 3]?.data"/>
                <div class="text-center screenshot-carousel-preview-sub" >{{ screenshots[index + 3]?.date_local }}</div>
            </div>
            <div v-else style="width: 100px; display: inline-block" />
            <v-icon size="large" v-show="index < screenshots.length - 3 " @click="$emit('forward', 3)" >fa-regular fa-circle-ellipsis</v-icon>
        </div>
    </div>
</template>

<style scoped>
    .screenshot-carousel-preview {
        overflow-x: hidden;
        width: 95%
    }
    .screenshot-img {
        height: 400px;
        max-width: 80%;
        object-fit: contain;
    }
    .screenshot-carousel-preview-img {
        width: 100px;
        max-height: 140px;
        object-fit: contain;
    }
    .screenshot-carousel-preview-selected {
        border: 5px solid var(--color-primary-lighter);
    }
    .v-icon {
        font-size: 4.5em;
        cursor: pointer;
    }
     .screenshot-carousel-preview-sub {
        font-size: 0.8em;
    }
</style>
